import * as React from 'react'
import { connect } from 'react-redux'

import { isFixedSizeEmbed } from 'embed/constants'

import * as commonActions from 'common/actions'
import { DepositsOffer } from 'embed/constants/models'
import { MultiProductState } from 'embed/reducers'

import { DepositsSortOption, Filter, OfferType, Product, RedirectType, SortDirection } from 'even-ts-static'
import { SavingsCalculatorView } from './index'

interface OwnProps {
  depositsOfferCount?: number
}

interface DispatchProps {
  dispatchDepositsCalculatorLoadedResults: (depositsOfferCount: number) => void
  dispatchOfferCta?: (offer: DepositsOffer) => void
  dispatchSortChanged?: (sortOption: DepositsSortOption, sortDirection: SortDirection) => null
}

interface StoreProps {
  depositAmountIntent?: number
  error: boolean
  offer?: DepositsOffer
}

type Props = OwnProps & DispatchProps & StoreProps

const SavingsCalculatorContainer = ({
  depositAmountIntent,
  dispatchDepositsCalculatorLoadedResults,
  dispatchOfferCta,
  error,
  offer,
}: Props) => {
  React.useEffect(() => {
    if (offer !== undefined) {
      const offerCount = 1 // Because we're loading the offer based on the offer ID query param, there's only ever one
      dispatchDepositsCalculatorLoadedResults(offerCount)
    }
  }, [offer])

  return (
    <SavingsCalculatorView
      offer={offer}
      depositAmountIntent={depositAmountIntent}
      dispatchOfferCta={dispatchOfferCta}
      error={error}
    />
  )
}

const mapStateToProps = (state: MultiProductState, ownProps: OwnProps): StoreProps => ({
  depositAmountIntent: state.filters[Product.Deposits]?.[Filter.DepositAmountIntentValue],
  error: !!state.rates.selected.loadOfferError?.[Product.Deposits],
  offer: state.rates.selected[Product.Deposits],
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchDepositsCalculatorLoadedResults: (depositsOfferCount: number) =>
    dispatch(commonActions.depositsCalculatorLoadedResults(depositsOfferCount)),
  dispatchOfferCta: (offer: DepositsOffer) =>
    dispatch(
      commonActions.redirectToOffer(offer, OfferType.Deposits, RedirectType.MANUAL, {
        openInNewTab: isFixedSizeEmbed(),
      }),
    ),
})

export const SavingsCalculator = connect(mapStateToProps, mapDispatchToProps)(SavingsCalculatorContainer)
